import type { FunctionComponent, PropsWithChildren } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './FormGrid.module.css';

export interface FormGridProps extends PropsWithChildren {
  inline?: boolean;
}

export const FormGrid: FunctionComponent<FormGridProps> = ({ children, inline = false }) => {
  const mods = useModifiers(
    styles,
    'formGrid',
    {
      inline,
    },
    { withBaseClass: true }
  );

  return <div className={mods}>{children}</div>;
};
